export const handleInPageSmoothScroll = (e, targetId) => {
  if (e) {
    e.preventDefault();
  }
  const element = document.getElementById(targetId.replace('#', ''));
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }
};
